type AdSlotProps = {
  label: string;
  slot?: string;
  className?: string;
};

export function AdSlot({ label, slot, className = "" }: AdSlotProps) {
  const client = import.meta.env.VITE_ADSENSE_CLIENT as string | undefined;
  const isConfigured = client && !client.includes("0000000000000000");

  return (
    <aside className={`ad-slot ${className}`} aria-label={label} data-ad-slot={slot ?? "auto"}>
      {isConfigured ? (
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client={client}
          data-ad-slot={slot ?? ""}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      ) : (
        <span>{label}</span>
      )}
    </aside>
  );
}
